var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_brand",
    transform: "translate(-554 -1978)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2367",
    "data-name": "Group 2367",
    transform: "translate(554 1978)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5328",
    "data-name": "Path 5328",
    d: "M40.5,81A40.5,40.5,0,1,1,81,40.5,40.546,40.546,0,0,1,40.5,81Zm0-76.14A35.64,35.64,0,1,0,76.14,40.5,35.68,35.68,0,0,0,40.5,4.86Z",
    fill: "#01358d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_696",
    "data-name": "Rectangle 696",
    transform: "translate(576.065 1998)",
    fill: "#fff",
    stroke: "#f9556d",
    strokeWidth: 3.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.661,
    height: 19.33,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.65,
    y: 1.65,
    width: 35.361,
    height: 16.03,
    rx: 0.35,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_697",
    "data-name": "Rectangle 697",
    transform: "translate(576.065 2020.742)",
    fill: "#fff",
    stroke: "#f9556d",
    strokeWidth: 3.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.256,
    height: 18.256,
    rx: 9,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.65,
    y: 1.65,
    width: 14.956,
    height: 14.956,
    rx: 7.35,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_698",
    "data-name": "Rectangle 698",
    transform: "translate(596.469 2020.742)",
    fill: "#fff",
    stroke: "#f9556d",
    strokeWidth: 3.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.256,
    height: 18.256,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.65,
    y: 1.65,
    width: 14.956,
    height: 14.956,
    rx: 0.35,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1598",
    "data-name": "Ellipse 1598",
    transform: "translate(618 1990)",
    fill: "#f9556d",
    stroke: "#fff",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 5.75,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.1f156e88ecf99ad3cfb2f5bdbddf472f.svg";
export { ForwardRef as ReactComponent };